import { Box, CircularProgress } from '@mui/material'

import { useRef, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { sleep } from 'src/mentor/helpers/utilityFunctions'
import { v4 as uuidv4 } from 'uuid'
import TimerCongratulatoryFlow from './CongratulatoryFlow/TimerCongratulatoryFlow'
import TimerController from './TimerComponent/TimerController'
import { FinishPracticeButton, PracticeTimerFinishDrawer } from './TimerComponent/styledComponents'
import { submitPracticeTimer } from './utils'
import dayjs from 'dayjs'

export default function PracticeTimer({
  timerId,
  src,
  srcId,
  title,
  description,
  bellType,
  durationType,
  minDuration,
  maxDuration,
  intervals,
  duration,
  timerBackground,
  beginButtonOverride,
}) {
  const [showFinishDrawer, setShowFinishDrawer] = useState(false)
  const pausePlayButtonRef = useRef(null)
  const [disableBothButtons, setDisableBothButtons] = useState(false)
  const [recording, setRecording] = useState(false)
  const [objectToSubmit, setObjectToSubmit] = useState(null)
  const navigate = useNavigate()
  const [clientSessionTime, setClientSessionTime] = useState(dayjs().format('YYYY-MM-DD HH:mm:ss'))
  const [showCongoDialog, setShowCongoDialog] = useState(false)
  const [clientSessionId, setClientSessionId] = useState(`SESS-${uuidv4()?.replace(/-/g, '')}`)

  async function backToPreviousPage() {
    setShowFinishDrawer(false)
    setShowCongoDialog(false)
    await sleep(200)
    navigate(-1)
  }

  async function handleRecordTimer() {
    setRecording(true)
    setDisableBothButtons(true)
    await submitPracticeTimer(
      {
        ...objectToSubmit,
        meditationId: timerId,
        clientSessionId: clientSessionId,
        clientCreatedTime: clientSessionTime,
        anonyms: !!timerId ? false : true,
      },
      src,
      srcId,
      () => {
        setShowFinishDrawer(false)
        setRecording(false)
        setDisableBothButtons(false)
        setShowCongoDialog(true)
        // backToPreviousPage()
      },
      {
        timerId,
        title,
        description,
        bellType,
        durationType,
        minDuration,
        maxDuration,
        duration,
      },
    )
  }

  function onTimerFinish(timerSubmissionObject) {
    setShowFinishDrawer(true)
    setObjectToSubmit(timerSubmissionObject)
  }

  function hideFinishDrawer() {
    setShowFinishDrawer(false)
  }

  function handleResumeTimer() {
    hideFinishDrawer()
    pausePlayButtonRef?.current?.click()
  }

  function closeCongoDialog() {
    setShowCongoDialog(false)
  }

  return (
    <>
      <TimerController
        bellType={bellType}
        title={title}
        description={description}
        duration={duration}
        durationType={durationType}
        maxDuration={maxDuration}
        minDuration={minDuration}
        intervals={intervals}
        timerBackground={timerBackground}
        beginButtonOverride={beginButtonOverride}
        onTimerFinish={onTimerFinish}
        pausePlayButtonRef={pausePlayButtonRef}
        backToPreviousPage={backToPreviousPage}
      />
      <PracticeTimerFinishDrawer open={showFinishDrawer} anchor="bottom">
        <div className="d-flex flex-column align-items-center gap-3 py-4">
          <FinishPracticeButton onClick={handleResumeTimer} disabled={disableBothButtons}>
            Continue Practice
          </FinishPracticeButton>
          <FinishPracticeButton
            onClick={handleRecordTimer}
            disabled={disableBothButtons}
            sx={{ position: 'relative' }}
          >
            {recording && (
              <Box sx={{ position: 'absolute', display: 'flex' }}>
                <CircularProgress size={24} thickness={4} sx={{ color: '#4c3f97' }} />
              </Box>
            )}
            Finish
          </FinishPracticeButton>
        </div>
      </PracticeTimerFinishDrawer>
      <TimerCongratulatoryFlow
        openDialog={showCongoDialog}
        backToPreviousPage={backToPreviousPage}
        clientSessionId={clientSessionId}
        clientCreatedTime={clientSessionTime}
        timerTitle={title}
        timerDuration={duration}
        timerMinDuration={minDuration}
        intervals={intervals}
        timerMaxDuration={maxDuration}
        timerBellType={bellType}
        timerType={durationType}
        timerId={timerId}
      />
    </>
  )
}
